/* BG COM : aperçu rapide (snippets/bgcom-quick-view), sorti du snippet le 04/10/2026 (vitesse r5.1) ; defer : les loupes des cartes
   sont posées juste avant DOMContentLoaded, après la feuille bgcom-quick-view.css (liée avant ce script, elle le retient). */
(function () {
  var overlay = document.getElementById('BgcomQvOverlay');
  if (!overlay) return;
  // Une seule initialisation par fenêtre : le filtre (bgcom-mc-2, ingestPage) ré-exécute
  // les scripts de la page, et chaque exécution ajoutait ses écouteurs (ajout au panier x3 à x10).
  if (overlay.__bgcomQvInit) return;
  overlay.__bgcomQvInit = true;

  var elImage = document.getElementById('BgcomQvImage');
  var elSku   = document.getElementById('BgcomQvSku');
  var elTitle = document.getElementById('BgcomQvTitle');
  var elPrice = document.getElementById('BgcomQvPrice');
  var elDesc  = document.getElementById('BgcomQvDesc');
  var elVarWrap = document.getElementById('BgcomQvVariants');
  var elVarSel  = document.getElementById('BgcomQvVariantSelect');
  var elConfig  = document.getElementById('BgcomQvConfig');
  var elError   = document.getElementById('BgcomQvError');
  var elQty   = document.getElementById('BgcomQvQty');
  var elAtc   = document.getElementById('BgcomQvAtc');
  var elFull  = document.getElementById('BgcomQvFull');
  var elClose = document.getElementById('BgcomQvClose');
  var elQtyMinus = document.getElementById('BgcomQvQtyMinus');
  var elQtyPlus  = document.getElementById('BgcomQvQtyPlus');
  var elBrand = document.getElementById('BgcomQvBrand');
  var elSum   = document.getElementById('BgcomQvSum');
  var elPills = document.getElementById('BgcomQvPills');
  var elVarLabel = document.getElementById('BgcomQvVarLabel');

  var currentProduct = null;
  var qvRatio = 0, qvCard = null;

  /* ---- bloc d'achat de la fiche (03/10/2026) ---- */
  var qvStock = null, qvConnected = false, qvIsPack = false, qvConfig = false;
  var SVG = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>'
  };
  function escHtml(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* « Nom | Marque - BG COM AGENCY » : le nom seul ; la marque devient le sourcil (jamais le fournisseur) */
  function cleanTitle(t) { return String(t || '').split(' | ')[0].trim(); }
  function okBrand(b) {
    b = String(b || '').trim();
    if (/innov/i.test(b)) b = 'Mister Paint';
    return (!b || /j[u\u00fc]e?r\x67en|PI\s*\/\/|bg\s*com/i.test(b)) ? '' : b; /* 03/10 : même filtre, sans le nom du fabricant en clair dans le HTML */
  }
  /* même règle que la fiche (skill bgcom-pdp §3.3) : « Nom | Marque - … » ; « MARQUE - Nom » = la marque quitte le nom
     et devient le sourcil ; sinon le vendor (jamais le fournisseur ni BG COM) */
  function nameParts(p) {
    var name = cleanTitle(p.title), parts = String(p.title || '').split(' | ');
    var b = parts.length > 1 ? okBrand(parts[1].split(' - ')[0]) : '';
    var m = name.match(/^([^a-z|]{2,24}?)\s+[-–]\s+(.{4,})$/);
    if (m && okBrand(m[1]) && (!b || b.toLowerCase() === m[1].trim().toLowerCase())) { b = okBrand(m[1]); name = m[2].trim(); }
    if (!b) b = okBrand(p.vendor);
    return { brand: b, name: name };
  }
  /* « Brillant (85% equivalent Peinture Poudre) » -> « Brillant 85% » (même règle que shortenPills de la fiche) */
  function shortOpt(o) {
    var full = String(o), s = full.split('(')[0].trim(), pm = full.match(/\((\d+)\s*%/);
    if (pm) s = (s + ' ' + pm[1] + '%').trim();
    return s || full;
  }
  /* quantité d'un conditionnement : « A l'unité (1) » = 1, « Par pack de 6 (…) » = 6 (même règle que la fiche) */
  function qtyOf(t) { var m = String(t).match(/\((\d+)\)/) || String(t).match(/de\s+(\d+)/i); return m ? parseInt(m[1], 10) : 1; }
  /* Offre du mois (11/10/2026, assets/bgcom-promo-holo.js) : la carte ouverte porte l'étiquette = cartes Conditionnement au prix remisé */
  function proCents(c) { return (qvRatio > 0 && qvRatio < 1) ? Math.round(c * qvRatio) : (window.bgcomOffreNet && qvCard ? window.bgcomOffreNet(qvCard, c) : c); }
  function imgUrl(u, w) { if (!u) return ''; u = String(u); return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }

  /* état de stock de la variante : data-stock du formulaire de la carte (« id:état:qté », règle de la pastille de la fiche) */
  function readStock(card) {
    var f = card.querySelector('.bgca[data-stock]'), map = null;
    if (f) {
      map = {};
      f.getAttribute('data-stock').split(',').forEach(function (x) {
        var p = x.split(':'); if (p.length >= 2) map[p[0]] = { st: p[1], q: parseInt(p[2], 10) || 0 };
      });
    }
    return map;
  }
  function stockOf(v) {
    var s = qvStock && qvStock[String(v.id)];
    return s || { st: v.available === false ? 'out' : (qvConfig ? 'aero' : 'in'), q: 0 };
  }
  function sumItem(icCls, ic, t, s) {
    return '<span class="bgcom-qv-sum__ic ' + icCls + '" aria-hidden="true">' + ic + '</span>' +
      '<span class="bgcom-qv-sum__tx"><span class="bgcom-qv-sum__t">' + t + '</span>' + (s ? '<span class="bgcom-qv-sum__s">' + s + '</span>' : '') + '</span>';
  }
  /* résumé 3 points : stock · livraison · Tarifs pro / Espace Pro. Délais de livraison tout compris (user, 03/10/2026) :
     en stock 24-48 h (règle finale du 03/10 nuit), sur commande 48-72 h, aérosol préparé à la teinte 24-48 h ; jamais « expédition » */
  function paintSum(v) {
    if (!v) return;
    var s = stockOf(v), st = s.st;
    var t = st === 'low' ? 'Plus que ' + s.q + ' en stock' : st === 'order' ? 'Sur commande' : st === 'out' ? 'Indisponible' : 'En stock';
    var dot = (st === 'low' || st === 'aero') ? 'in' : st;
    var hk = /(^|,)(Cat_Crochets|Collection-Crochets)(,|$)/.test(((currentProduct && currentProduct.tags) || []).join(','));   /* crochets : 3-5 jours (user, 11/10/2026) */
    var deliv = st === 'out' ? '' : hk ? '3-5 jours' : st === 'order' ? '48-72 h' : st === 'aero' ? '24-48 h' : '24-48 h';
    var key = dot + '|' + t + '|' + deliv + '|' + qvConnected;
    if (elSum.getAttribute('data-k') === key) return;   /* le sonar ne rejoue qu'au changement */
    elSum.setAttribute('data-k', key);
    var h = '<div class="bgcom-qv-sum__i" role="listitem">' + sumItem('bgcom-qv-sum__dot is-' + dot, '', t, '') + '</div>';
    if (deliv) h += '<div class="bgcom-qv-sum__i" role="listitem">' + sumItem('', SVG.truck, 'Livraison', deliv) + '</div>';
    h += qvConnected
      ? '<a class="bgcom-qv-sum__i is-pro" role="listitem" href="/account">' + sumItem('is-ok', SVG.user, 'Espace Pro', 'Mon compte →') + '</a>'
      : '<a class="bgcom-qv-sum__i" role="listitem" href="/pages/compte-pro">' + sumItem('', SVG.user, 'Tarifs pro', 'Connectez-vous') + '</a>';
    elSum.innerHTML = h;
  }
  function paintBuy(v) {
    var out = v && stockOf(v).st === 'out';
    elAtc.disabled = !!out;
    elAtc.textContent = out ? 'Indisponible' : 'Ajouter au panier';
  }

  /* CONDITIONNEMENT (cartes photo de la fiche) ou autres variantes (pastilles) ; le select reste la source de vérité */
  function renderVariants(product) {
    var vs = product.variants || [];
    var opt = product.options && product.options[0];
    var optName = opt && (opt.name || opt);
    qvIsPack = vs.length > 1 && vs.length <= 4 && (/pack|condition|lot|carton/i.test(String(optName)) ||
      vs.every(function (v) { return /\(\d+\)|de\s+\d+/i.test(v.title); }));
    var pills = vs.length > 1 && vs.length <= 8 && vs.every(function (v) { return String(v.title).length <= 48; });
    elVarLabel.textContent = qvIsPack ? 'Conditionnement' : ((optName && typeof optName === 'string' && optName !== 'Title') ? optName : 'Variante');
    elVarWrap.classList.toggle('has-pills', qvIsPack || pills);
    elPills.classList.toggle('is-pack', qvIsPack);
    if (qvIsPack) {
      elPills.innerHTML = vs.map(function (v) {
        var q = qtyOf(v.title), ht = proCents(v.price), per = Math.round(ht / q);
        var img = (v.featured_image && v.featured_image.src) || product.featured_image;
        return '<button type="button" class="bgcom-qv-pack" role="radio" aria-checked="false" data-v="' + v.id + '"' + (v.available === false ? ' data-off="1"' : '') + '>' +
          '<span class="bgcom-qv-pack__ck" aria-hidden="true">' + SVG.check + '</span>' +
          (img ? '<img class="bgcom-qv-pack__img" src="' + escHtml(imgUrl(img, 200)) + '" alt="" loading="lazy">' : '') +
          '<span class="bgcom-qv-pack__n">' + (q === 1 ? 'À l’unité' : 'Pack de ' + q) + '</span>' +
          '<span class="bgcom-qv-pack__p">' + euros(per) + '<small>HT / unité</small></span>' +
          (q > 1 ? '<span class="bgcom-qv-pack__soit">Soit ' + euros(ht) + ' le pack</span>' : '') +
          '<span class="bgcom-qv-pack__ttc">' + euros(Math.round(ht * 1.2)) + ' TTC</span></button>';
      }).join('');
    } else {
      elPills.innerHTML = pills ? vs.map(function (v) {
        return '<button type="button" class="bgcom-qv-pill" role="radio" aria-checked="false" data-v="' + v.id + '"' + (v.available === false ? ' data-off="1"' : '') + '>' + escHtml(v.title) + '</button>';
      }).join('') : '';
    }
    markChosen();
  }
  function markChosen() {
    elPills.querySelectorAll('[data-v]').forEach(function (x) { x.setAttribute('aria-checked', String(x.getAttribute('data-v') === String(elVarSel.value))); });
  }

  function euros(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  function stripHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    /* descriptions that start with a <style> block (324 products): CSS / scripts are not text */
    tmp.querySelectorAll('style,script,noscript,template').forEach(function (n) { n.remove(); });
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  }

  /* BGCOM lot (01/10/2026): the clicked card's unit (« / sachet de 100 ») goes with the price; per variant when the
     card carries data-bgcom-lotv (lot changes with the variant), else the card's own value */
  var qvLot = '', qvLotMap = null;
  function applyLot(variantId) {
    if (!qvLot) { elPrice.removeAttribute('data-bgcom-lot'); elPrice.style.removeProperty('--bgcom-lot'); return; }
    var v = (qvLotMap && variantId != null && qvLotMap[String(variantId)]) ? JSON.stringify(qvLotMap[String(variantId)]) : qvLot;
    elPrice.setAttribute('data-bgcom-lot', '');
    elPrice.style.setProperty('--bgcom-lot', v);
  }

  /* BGCOM promo (01/10/2026): the variant's compare-at price (/products/{handle}.js) goes to the builder, which shows
     the blue promotion pill and the struck HT only when compare_at > price (null or lower = unchanged output) */
  function publicPrice(variant) {
    if (window.bgcomProRows) return window.bgcomProRows(variant.price, 0, variant.compare_at_price);
    var ht = variant.price, ttc = Math.round(ht * 1.2);
    return '<div class="bgcom-price-ttc"><span class="bgcom-money">' + euros(ttc) + '</span> TTC</div>' +
           '<div class="bgcom-price-ht"><span class="bgcom-money">' + euros(ht) + '</span> HT</div>';
  }

  /* ---- Configurator rendering (mirrors bgcom-product-configurator) ---- */
  function renderConfig(cfg) {
    elConfig.innerHTML = '';
    if (!cfg || !cfg.fields || !cfg.fields.length) return;

    cfg.fields.forEach(function (f, i) {
      if (!f.name) return;
      var type = f.type || 'text';
      var id = 'BgcomQvCfg-' + i;
      var wrap = document.createElement('div');
      wrap.className = 'bgcom-qv-field';
      wrap.setAttribute('data-cfg-name', f.name);
      if (f.required) wrap.setAttribute('data-cfg-required', '1');
      wrap.setAttribute('data-cfg-label', f.label || f.name);
      if (f.hide_when) wrap.setAttribute('data-cfg-hidewhen', JSON.stringify(f.hide_when));
      if (f.show_when) wrap.setAttribute('data-cfg-showwhen', JSON.stringify(f.show_when));

      var label = '<label class="bgcom-qv-flabel"' + (type === 'radio' ? '' : ' for="' + id + '"') + '>' + (f.label || f.name) +
        (f.required ? ' <span class="bgcom-qv-req">*</span>' : '') + '</label>';

      var control = '';
      if (type === 'select') {
        control = '<select id="' + id + '" data-cfg-input>' +
          '<option value="">Choisir</option>' +
          (f.options || []).map(function (o) {
            return '<option value="' + String(o).replace(/"/g, '&quot;') + '"' + (f.default === o ? ' selected' : '') + '>' + o + '</option>';
          }).join('') + '</select>';
      } else if (type === 'radio') {
        control = '<div class="bgcom-qv-radiogroup" role="radiogroup" aria-label="' + escHtml(f.label || f.name) + '" style="--n:' + Math.min((f.options || []).length, 4) + '">' +
          (f.options || []).map(function (o, j) {
            return '<label class="bgcom-qv-radio"><input type="radio" name="' + id + '" value="' +
              String(o).replace(/"/g, '&quot;') + '" data-cfg-input' + (f.default === o ? ' checked' : '') + '><span title="' + escHtml(o) + '">' + escHtml(shortOpt(o)) + '</span></label>';
          }).join('') + '</div>' +
          ((f.options || []).indexOf('Autre') > -1 ? '<input type="text" data-cfg-other placeholder="' + escHtml(OTHER_PH[f.name] || OTHER_PH['']) + '" aria-label="' +
            escHtml(OTHER_PH[f.name] || OTHER_PH['']) + '" maxlength="80" autocomplete="off" style="display:none;margin-top:10px">' : '');
      } else if (type === 'textarea') {
        control = '<textarea id="' + id + '" rows="' + (f.rows || 3) + '" placeholder="' +
          (f.placeholder || '').replace(/"/g, '&quot;') + '" data-cfg-input>' + (f.default || '') + '</textarea>';
      } else if (type === 'ral') {
        control = '<input type="text" id="' + id + '" list="bgcom-ral-classic" autocomplete="off" placeholder="' +
          (f.placeholder || 'Tapez un code ou un nom RAL...').replace(/"/g, '&quot;') + '" value="' + (f.default || '') + '" data-cfg-input>';
      } else {
        control = '<input type="text" id="' + id + '" placeholder="' +
          (f.placeholder || '').replace(/"/g, '&quot;') + '" value="' + (f.default || '') + '" data-cfg-input>';
      }

      var help = f.help ? '<p class="bgcom-qv-fhelp">' + f.help + '</p>' : '';
      wrap.innerHTML = label + control + help;
      elConfig.appendChild(wrap);
    });

    if (elConfig.children.length) elConfig.insertAdjacentHTML('afterbegin', '<p class="bgcom-qv-h">Personnalisation</p>');
    wireConfigConditions();
    if (window.bgcomFinish) window.bgcomFinish(elConfig);   /* tuiles « Matière » (snippets/bgcom-finish-swatch) */
  }

  function fieldValue(wrap) {
    var inputs = wrap.querySelectorAll('[data-cfg-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].type === 'radio') { if (inputs[i].checked) return otherValue(wrap, inputs[i].value); }
      else return inputs[i].value;
    }
    return '';
  }

  /* 13/10/2026 : « Autre » ouvre un champ libre ; envoyé dans la même propriété (« Autre : … », « Autre » s'il reste vide) pour que
     n8n la retrouve sous son nom habituel, comme la fiche (bgcom-pdp-polish.js) et le tiroir pro (bgpro-sug.js). Le champ est dans
     .bgcom-qv-field : masqué et non envoyé avec lui (Fine Texture). */
  var OTHER_PH = { ASPECT: 'Pr\u00e9cisez l\u2019aspect (ex. martel\u00e9)', BRILLANCE: 'Pr\u00e9cisez la brillance (ex. 50\u00a0%)', '': 'Pr\u00e9cisez votre choix\u2026' };
  function otherValue(wrap, v) {
    var o = wrap.querySelector('[data-cfg-other]'), t = o ? o.value.trim() : '';
    return v === 'Autre' && t ? 'Autre : ' + t : v;
  }

  function findFieldByName(name) {
    return elConfig.querySelector('.bgcom-qv-field[data-cfg-name="' + (name || '').replace(/"/g, '\\"') + '"]');
  }

  function wireConfigConditions() {
    var fields = elConfig.querySelectorAll('.bgcom-qv-field');
    fields.forEach(function (wrap) {
      var hide = wrap.getAttribute('data-cfg-hidewhen');
      var show = wrap.getAttribute('data-cfg-showwhen');
      if (!hide && !show) return;
      var rule = JSON.parse(hide || show);
      var trigger = findFieldByName(rule.field);
      function evaluate() {
        var val = trigger ? fieldValue(trigger) : '';
        var match = val === rule.equals;
        var visible = hide ? !match : match;
        wrap.style.display = visible ? '' : 'none';
        wrap.setAttribute('data-cfg-hidden', visible ? '0' : '1');
      }
      if (trigger) {
        trigger.querySelectorAll('[data-cfg-input]').forEach(function (inp) {
          inp.addEventListener('change', evaluate);
          inp.addEventListener('input', evaluate);
        });
      }
      evaluate();
    });
  }

  function collectProperties() {
    var props = {};
    var fields = elConfig.querySelectorAll('.bgcom-qv-field');
    for (var i = 0; i < fields.length; i++) {
      var wrap = fields[i];
      if (wrap.getAttribute('data-cfg-hidden') === '1') continue; // skip hidden
      var name = wrap.getAttribute('data-cfg-name');
      var val = fieldValue(wrap).trim();
      var required = wrap.getAttribute('data-cfg-required') === '1';
      if (required && !val) {
        wrap.classList.add('bgcom-qv-invalid');
        var first = wrap.querySelector('[data-cfg-input]');
        try { wrap.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
        if (first && first.type !== 'radio') setTimeout(function () { first.focus({ preventScroll: true }); }, 250);
        return { error: 'Merci de renseigner : ' + (wrap.getAttribute('data-cfg-label') || name) };
      }
      wrap.classList.remove('bgcom-qv-invalid');
      if (val) props[name] = val;
    }
    return { props: props };
  }

  /* 04/10/2026 (r5.2, jury a11y, WCAG 2.4.3) : la fenêtre déclare aria-modal : le focus y entre à l'ouverture (bouton Fermer), la
     tabulation y reste (boucle), et il revient au bouton qui l'a ouverte à la fermeture (Échap, Fermer, clic sur le fond). */
  var qvOpener = null;
  function openModal() {
    if (overlay.hidden && !qvOpener) qvOpener = document.activeElement;
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      if (!overlay.contains(document.activeElement)) { try { elClose.focus({ preventScroll: true }); } catch (e) {} }
    });
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; overlay.setAttribute('aria-hidden', 'true'); }, 200);
    var o = qvOpener; qvOpener = null;
    if (o && o.focus && o !== document.body && document.documentElement.contains(o)) { try { o.focus({ preventScroll: true }); } catch (e) {} }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || overlay.hidden) return;
    var f = Array.prototype.filter.call(overlay.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (x) { return !!(x.offsetWidth || x.offsetHeight || x.getClientRects().length); });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], ae = document.activeElement;
    if (!overlay.contains(ae)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && ae === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && ae === last) { e.preventDefault(); first.focus(); }
  });

  /* 05/10/2026 (user : « should always be » le configurateur de la fiche) : crochets = configurateur de référence de la fiche
     (snippets/bgcom-hook-picker, mode 'qv', servi par templates/product.bgcom-pk.liquid) à la place de la liste des variantes et de la
     barre quantité / ajout de l'aperçu ; les autres produits gardent l'aperçu tel quel. */
  var elPk = null, pkCache = {};
  function fetchPk(handle) {
    if (pkCache[handle] != null) return Promise.resolve(pkCache[handle]);
    return fetch('/products/' + handle + '?view=bgcom-pk', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { pkCache[handle] = t; return t; })
      .catch(function () { return ''; });
  }
  function mountPicker(html) {
    if (!elPk) { elPk = document.createElement('div'); elPk.className = 'bgcom-qv-pk'; elPk.id = 'BgcomQvPk'; elConfig.parentNode.insertBefore(elPk, elConfig); }
    elPk.innerHTML = html && html.indexOf('data-bgcom-pk-qv') > -1 ? html : '';
    var root = elPk.querySelector('[data-bgcom-pk-qv]');
    if (root && !window.bgcomHookPickerInit) {   /* 1re fois : le script du fragment (inerte via innerHTML) définit la fonction */
      var sc = elPk.querySelector('script:not([type])');
      if (sc) { var n = document.createElement('script'); n.textContent = sc.textContent; document.head.appendChild(n); }
    }
    var ok = !!(root && window.bgcomHookPickerInit);
    if (ok) {
      window.bgcomHookPickerInit(root, {
        onVariant: function (v) { if (String(elVarSel.value) !== String(v.id)) { elVarSel.value = String(v.id); elVarSel.dispatchEvent(new Event('change')); } },
        onAdded: function () { setTimeout(function () { closeModal(); if (typeof window.bgproOpen === 'function') window.bgproOpen(); }, 700); }
      });
    } else elPk.innerHTML = '';
    overlay.classList.toggle('is-pk', ok);
    return ok;
  }

  function selectedVariant() {
    if (!currentProduct) return null;
    if (currentProduct.variants.length === 1) return currentProduct.variants[0];
    var id = parseInt(elVarSel.value, 10);
    return currentProduct.variants.find(function (v) { return v.id === id; }) || currentProduct.variants[0];
  }

  function loadProduct(card) {
    var handle = card.getAttribute('data-handle');
    if (!handle) return;
    var fallbackImg = card.querySelector('.bgcom-product-img img');
    var cfgRaw = card.getAttribute('data-configurator');

    qvLot = card.hasAttribute('data-bgcom-lot') ? (card.style.getPropertyValue('--bgcom-lot') || '').trim() : '';
    qvLotMap = null;
    if (qvLot && card.getAttribute('data-bgcom-lotv')) { try { qvLotMap = JSON.parse(card.getAttribute('data-bgcom-lotv')); } catch (e) { qvLotMap = null; } }
    var cardVariant = card.getAttribute('data-variant-id');
    var pkPre = (card.getAttribute('data-all-skus') || '').trim().split(/\s+/).length > 1 ? fetchPk(handle) : null;
    qvStock = readStock(card);
    qvConfig = !!cfgRaw;
    qvCard = card;

    // Clone the card's already-rendered price block (wholesale-correct)
    var cardPrice = card.querySelector('.bgcom-samita-target');
    qvRatio = 0;
    /* pro chez qui l'Offre du mois gagne (étiquette data-bgpp-pro, assets/bgcom-promo-holo.js) : pas de ratio pro, les prix suivent l'étiquette */
    if (cardPrice && cardPrice.querySelector('.bgp-badge') && !card.querySelector('.bgpp[data-bgpp-pro]:not([hidden])')) {
      var qvHero = cardPrice.querySelector('.bgcom-price-ht .bgcom-money'), qvBase = parseInt(card.getAttribute('data-price'), 10) || 0;
      var qvHeroC = qvHero ? Math.round(parseFloat(qvHero.textContent.replace(/[^\d,]/g, '').replace(',', '.')) * 100) : 0;
      if (qvHeroC && qvBase && qvHeroC < qvBase) qvRatio = qvHeroC / qvBase;
    }

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        currentProduct = product;
        elError.hidden = true; elError.textContent = '';
        var np = nameParts(product);
        elBrand.textContent = np.brand; elBrand.hidden = !np.brand;
        elTitle.textContent = np.name;
        elImage.src = product.featured_image ? imgUrl(product.featured_image, 1000) : (fallbackImg ? fallbackImg.src : '');
        elImage.alt = cleanTitle(product.title);
        qvConnected = !!document.querySelector('.bgpro-procta--in') || qvRatio > 0 || !!card.querySelector('.bgpp[data-bgpp-pro]');
        elSum.removeAttribute('data-k');
        elFull.href = '/products/' + product.handle;

        var firstVariant = product.variants[0];
        if (cardVariant) firstVariant = product.variants.find(function (v) { return String(v.id) === String(cardVariant); }) || firstVariant;
        elSku.textContent = firstVariant.sku ? 'Réf. ' + firstVariant.sku : '';

        // Price: prefer the card's rendered price (handles Samita wholesale)
        if (cardPrice && cardPrice.classList.contains('bgcom-price-ready')) {
          elPrice.innerHTML = cardPrice.innerHTML.replace(/<i class="bgm-spark"[^>]*><\/i>/g, '').replace(/ is-spk/g, '');   /* a clone never sparkles */
        } else {
          elPrice.innerHTML = publicPrice(firstVariant);
        }
        if (window.bgcomOffreQv) window.bgcomOffreQv(elPrice, card, firstVariant);
        applyLot(cardPrice && cardPrice.classList.contains('bgcom-price-ready') ? cardVariant : firstVariant.id);

        elDesc.textContent = '';   /* pas de description dans l'aperçu (03/10/2026) : la fiche complète la porte */

        if (product.variants.length > 1) {
          elVarSel.innerHTML = product.variants.map(function (v) {
            return '<option value="' + v.id + '">' + v.title + '</option>';
          }).join('');
          elVarSel.value = String(firstVariant.id);
          elVarWrap.hidden = false;
          renderVariants(product);
        } else {
          elVarWrap.hidden = true;
          elPills.innerHTML = '';
        }

        // Configurator
        if (cfgRaw) {
          try { renderConfig(JSON.parse(cfgRaw)); }
          catch (e) { elConfig.innerHTML = ''; }
        } else {
          elConfig.innerHTML = '';
        }

        // reset ATC + qty
        elAtc.classList.remove('is-added');
        paintSum(firstVariant);
        paintBuy(firstVariant);
        elQty.value = '1';
        var info = overlay.querySelector('.bgcom-qv-info'), modal = overlay.querySelector('.bgcom-qv-modal');
        if (info) info.scrollTop = 0;
        if (modal) modal.scrollTop = 0;

        (product.variants.length > 1 && !cfgRaw ? (pkPre || fetchPk(product.handle)) : Promise.resolve('')).then(function (html) {
          if (currentProduct !== product) return;
          mountPicker(html);
          openModal();
        });
      })
      .catch(function () { window.location.href = '/products/' + handle; });
  }

  // qty
  elQtyMinus.addEventListener('click', function () { elQty.value = Math.max(1, (parseInt(elQty.value, 10) || 1) - 1); });
  elQtyPlus.addEventListener('click', function () { elQty.value = Math.min(9999, (parseInt(elQty.value, 10) || 1) + 1); });

  // variant change → the pro ratio of the opened card applied to this variant (same rule as the catalogue renderer)
  elVarSel.addEventListener('change', function () {
    var v = selectedVariant();
    if (!v) return;
    elSku.textContent = v.sku ? 'Réf. ' + v.sku : '';
    elPrice.innerHTML = (qvRatio > 0 && qvRatio < 1 && window.bgcomProRows) ? window.bgcomProRows(Math.round(v.price * qvRatio), v.price) : publicPrice(v);
    if (window.bgcomOffreQv) window.bgcomOffreQv(elPrice, qvCard, v);
    applyLot(v.id);
    markChosen();
    paintSum(v);
    paintBuy(v);
  });
  elPills.addEventListener('click', function (e) {
    var b = e.target.closest('[data-v]'); if (!b) return;
    if (elVarSel.value === b.getAttribute('data-v')) return;
    elVarSel.value = b.getAttribute('data-v');
    elVarSel.dispatchEvent(new Event('change'));
  });
  /* un champ rempli perd son contour d'erreur tout de suite ; le message part quand tout est bon */
  function clearInvalid(e) {
    var w = e.target && e.target.closest ? e.target.closest('.bgcom-qv-field') : null;
    if (!w || !w.classList.contains('bgcom-qv-invalid') || !fieldValue(w).trim()) return;
    w.classList.remove('bgcom-qv-invalid');
    if (!elConfig.querySelector('.bgcom-qv-invalid')) { elError.hidden = true; elError.textContent = ''; }
  }
  elConfig.addEventListener('input', clearInvalid);
  elConfig.addEventListener('change', clearInvalid);
  elConfig.addEventListener('change', function (e) {
    var w = e.target.type === 'radio' ? e.target.closest('.bgcom-qv-field') : null, o = w && w.querySelector('[data-cfg-other]');
    if (!o) return;
    var c = w.querySelector('input[type="radio"]:checked'), on = !!c && c.value === 'Autre';
    o.style.display = on ? '' : 'none';
    if (on && e.isTrusted) o.focus();
  });

  // add to cart
  elAtc.addEventListener('click', function () {
    var variant = selectedVariant();
    if (!variant) return;

    var collected = collectProperties();
    if (collected.error) {
      elError.textContent = collected.error;
      elError.hidden = false;
      return;
    }
    elError.hidden = true;

    elAtc.disabled = true;
    elAtc.textContent = 'Ajout…';

    var body = { id: variant.id, quantity: parseInt(elQty.value, 10) || 1 };
    if (collected.props && Object.keys(collected.props).length) body.properties = collected.props;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        elAtc.classList.add('is-added');
        elAtc.textContent = 'Ajouté au panier';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (window.bgcomRefreshCartCount) { window.bgcomRefreshCartCount(); }
        var cartTrigger = document.querySelector('[aria-controls="CartDrawer"]');
        setTimeout(function () { closeModal(); if (typeof window.bgproOpen === 'function') window.bgproOpen(); else if (cartTrigger) cartTrigger.click(); }, 700);
      })
      .catch(function () { elAtc.disabled = false; elAtc.textContent = 'Réessayer'; });
  });

  // triggers on cards
  function addTriggers(root) {
    (root || document).querySelectorAll('.bgcom-card-wrap').forEach(function (card) {
      var imgWrap = card.querySelector('.bgcom-product-img');
      /* machines d'occasion (snippets/bgcom-machine-card) : jamais d'aperçu rapide, la fiche seulement */
      if (!imgWrap || card.hasAttribute('data-bgcom-machine') || card.querySelector('.bgcom-qv-trigger')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bgcom-qv-trigger';
      btn.setAttribute('aria-label', 'Aperçu rapide');
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>';
      var host = imgWrap.parentElement || imgWrap;
      host.style.position = 'relative';
      host.appendChild(btn);
    });
  }
  /* ONE delegated listener (01/10/2026): cards rebuilt by the search / filters (snippets/bgcom-mc-2) are copies of the
     server cards, button included but without its listener; the click is caught here for every card, old or new */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.bgcom-qv-trigger') : null;
    if (!btn) return;
    var card = btn.closest('.bgcom-card-wrap');
    if (!card || card.hasAttribute('data-bgcom-machine')) return;
    e.preventDefault(); e.stopPropagation();
    if (overlay.hidden) { var ae0 = document.activeElement; qvOpener = (ae0 && ae0 !== document.body && card.contains(ae0)) ? ae0 : btn; }
    loadProduct(card);
  }, true);
  addTriggers(document);
  document.addEventListener('page:loaded', function () { setTimeout(function () { addTriggers(document); }, 300); });

  elClose.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeModal(); });
})();
